<template>
  <div class="collect">
    <top-nav ref="TopNav"></top-nav>
    <!-- <van-nav-bar title="我的收藏" fixed   style="z-index: 1000">
      <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: .25rem" @click="goBack"></van-icon>
      <span style="z-index: 1001" slot="right" @click="edit()" v-if="!redact">编辑</span>
      <span style="z-index: 1001" slot="right" @click="edit()" v-if="redact">完成</span>
      <van-icon style="margin-left: .1rem" slot="right" class="iconfont icon-zhankai" @click="onClickRight()"></van-icon>
    </van-nav-bar> -->

    <GlobTopNav title="我的收藏" :rightHidden="false">
      <div @click="edit">
        <span v-if="!redact">编辑</span>
        <span v-if="redact">完成</span>
      </div>
    </GlobTopNav>

    <div class="van-content">
      <div class="nodata text-cent" v-if="finished && datas == ''">
        <img src="./../../../assets/img/sc-null.png" />
        <span class="text">还没有收藏哟~</span>
        <div @click="go()" class="visit-the">去逛逛</div>
      </div>

      <van-list v-model="loading" :finished="finished" @load="getDatas" :offset="-1">
        <van-checkbox-group v-model="onDatas">
          <div class="list" v-for="(items, index) in datas" :key="items.id">
            <van-checkbox
              :label-disabled="redact"
              :name="items"
              checked-color="rgba(226, 49, 48, 1)"
              v-if="redact"
            ></van-checkbox>
            <van-swipe-cell
              :class="redact == true ? 'active' : ''"
              :disabled="redact"
              style="z-index: 100"
              :right-width="60"
              :left-width="0"
            >
              <div>
                <van-card class="goodsonelist">
                  <div slot="thumb" class="goodsimgbox" @click="godetail(items.id_product)">
                    <img onerror="src='/static/errorimg1.png'" :src="items.image" />
                    <span v-if="items.status == 0" class="overGood">下架</span>
                  </div>
                  <div
                    @click="godetail(items.id_product)"
                    slot="title"
                    class="ellipseal van-card-title"
                    style="-webkit-box-orient: vertical"
                  >
                    <span class="tagbox">
                      <span class="tag xl" v-if="items.source == 4"> 一乡一物 </span>
                      <span class="tag xl" v-if="items.source == 3">卡券</span>
                      <span class="tag zc" v-if="items.source == 2">直充</span>
                      <span plain class="tag jd" v-if="items.source == 1">优选</span>
                      <span class="tag yx" v-if="items.source == 6">严选</span>
                    </span>
                    {{ items.name }}
                  </div>
                  <div slot="desc" class="van-card-desc theme-col">
                    <span v-if="items.point">{{ items.point }}{{ unit }}</span>
                    <span v-if="items.cash">
                      <span v-if="items.point">+</span>
                      <span>{{ items.cash }}</span>
                      <span>元</span>
                    </span>
                    <span
                      v-if="$store.state.webCount.market_status == 1"
                      style="font-size: 0.24rem; text-decoration: line-through; color: #9d9d9d"
                    >
                      市场价:{{ items.market_price }}元
                    </span>
                  </div>
                  <!-- <div slot="footer">
                    <van-icon
                      v-if="redact == true"
                      class="iconfont icon-shanchu ft3"
                      size="16"
                      @click.stop="remove(items.id, index)"
                    ></van-icon>
                  </div> -->
                </van-card>
              </div>
              <span slot="right">
                <button class="clearbtn theme-bd theme-bg" @click="remove(items.id, index)">
                  删除
                </button>
              </span>
            </van-swipe-cell>
          </div>
        </van-checkbox-group>
        <div v-if="!loading && finished && datas != ''" class="nomore">
          <div class="theEnd">已经到底了</div>
        </div>
      </van-list>
    </div>
    <div v-if="redact == true" class="van-submit-bar">
      <div style="position: relative" class="van-submit-bar__bar">
        <van-checkbox
          style="margin-left: 0.15rem"
          checked-color="rgba(226, 49, 48, 1)"
          v-model="checkedall"
          class="checkall"
        >
          全选
        </van-checkbox>
        <button
          class="van-button theme-bd theme-col van-button--normal delcollect bg-fff"
          @click="removeGoods()"
        >
          <span class="van-button__text">删除</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FooterNav from "@/components/footernav";
import TopNav from "../../../components/topnav";
export default {
  name: "cart",
  components: {
    FooterNav,
    TopNav
  },
  data() {
    return {
      checkedall: false,
      datas: [],
      onDatas: [],
      page: 0,
      finished: false,
      loading: false,
      redact: false //编辑开关
    };
  },
  watch: {
    checkedall: function() {
      var _this = this;
      if (this.checkedall) {
        _this.onDatas = [];
        $.each(this.datas, function(index, items) {
          _this.onDatas.push(items);
        });
      }
      if (!this.checkedall && this.onDatas.length == this.datas.length) {
        _this.onDatas = [];
      }
    },
    datas: function() {
      this.onDatas.length == this.datas.length
        ? (this.checkedall = true)
        : (this.checkedall = false);
    },
    onDatas: function() {
      this.onDatas.length == this.datas.length
        ? (this.checkedall = true)
        : (this.checkedall = false);
    }
  },
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    //积分价格
    points_prices: function() {
      var _this = this;
      var total = 0;
      $.each(_this.onDatas, function(index, items) {
        total += items.nums * items.points_prices;
      });
      return total;
    },
    //现金价格
    money_price: function() {
      var _this = this;
      var total = 0;
      $.each(_this.onDatas, function(index, items) {
        total += items.nums * items.money_price;
      });
      return total;
    }
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    edit: function() {
      this.redact = !this.redact;
    },
    go: function() {
      this.$router.push({ path: "/goodsList", query: { id: -1 } });
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    godetail: function(id) {
      if (this.redact) {
        return false;
      }
      this.$router.push({ path: "/goodslist/goods", query: { id: id } });
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      //        setTimeout(() => {
      //          this.page++
      this.$api.get(
        "user/collection/list",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            _this.finished = true;
            _this.loading = false;
            if (res.data.data.length == 0) {
              _this.finished = true;
              _this.loading = false;
            } else {
              for (let i = 0; i < res.data.data.length; i++) {
                _this.datas.push(res.data.data[i]);
              }
              _this.loading = false;
            }
          } else {
            this.$toast.alert(res.data.message);
            _this.loading = false;
          }
        }
      );
      //        },50)
    },

    removeGoods: function() {
      var _this = this;
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (this.redact && this.onDatas.length != 0) {
        this.$dialog
          .confirm({
            title: "提示",
            message: "确定从收藏夹移除该商品？"
          })
          .then(() => {
            var onDatasId = [];
            $.each(this.onDatas, function(index, items) {
              onDatasId.push(items.id);
            });
            this.$api.post(
              "/user/collection/delete",
              {
                id_example: mallid,
                token_user: isUser,
                id_cocollection: onDatasId
              },
              res => {
                if (res.data.code == "100") {
                  this.$toast("删除成功！");
                  $.each(this.onDatas, function(index, items) {
                    _this.datas.splice($.inArray(items, _this.datas), 1);
                  });
                  //                  this.datas = []
                  //                  this.getDatas()
                }
              }
            );
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$toast("请选择商品");
      }
    },
    remove: function(id, index) {
      var _this = this;
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定从收藏夹移除该商品？"
        })
        .then(() => {
          this.$api.post(
            "/user/collection/delete",
            { id_example: mallid, token_user: isUser, id_cocollection: id },
            res => {
              if (res.data.code == "100") {
                this.$toast("删除成功！");
                this.datas.splice(index, 1);
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  mounted() {}
};
</script>
<style lang="less">
.collect {
  min-height: 100vh;
  background-color: #f5f5f5;

  .van-submit-bar {
    height: 1.18rem;
    display: flex;
    align-items: center;
  }

  .van-submit-bar__bar {
    width: 100%;
    padding: 0 0.3rem !important;
    box-sizing: border-box !important;
    padding: 0;
    display: flex;
    justify-content: space-between;

    .delcollect {
      width: 2.5rem;
      height: 0.8rem;
      background: #fdf5f5;
      border-radius: 0.5rem;
      border: 0.02rem solid #e23331;
      font-size: 0.3rem;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 400;
      color: #e23331;
      line-height: 0.42rem;
    }
    .payorder {
      margin: 0.1rem 0.3rem;
      height: 0.8rem;
      border-radius: 0.5rem;
    }
    .van-submit-bar__price {
      width: 100%;
      line-height: 0.32rem !important;
      display: flex;
      justify-content: space-between;
    }

    .clearbtn {
      width: 1.2rem;
      height: 100%;
      text-align: center;
    }
  }

  .van-content {
    padding-bottom: 1.07rem;

    .list {
      width: 100%;
      display: flex;
      align-items: center;
      background-color: #fff;
      box-sizing: border-box;
      padding: 0 0.3rem;
      margin-bottom: 0.2rem;
    }

    .van-checkbox {
      display: flex;
      align-items: center;
      background-color: #fff;
      padding: 0.2rem 0;
      padding-right: 0.3rem;
    }

    .van-swipe-cell {
      width: 100%;
      background-color: #fff;
    }
    .van-cell-swipe__wrapper {
      width: 100%;
      position: relative;
      z-index: 99;
    }

    .goodsonelist {
      width: 90%;
      position: relative;
      padding: 0.2rem 0 !important;
      background-color: #fff;

      .van-card__header {
        height: 100%;
      }

      .van-card__thumb {
        width: 1.8rem;
        height: 1.8rem;

        .goodsimgbox {
          width: 1.8rem;
          height: 1.8rem;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .van-card__content {
        position: relative;

        .ellipseal {
          width: 100%;
          max-height: 1.2rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #262626;
          line-height: 0.42rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          display: -moz-box;
          display: box;
          -webkit-line-clamp: 3; //共显示几行，再多就是省略号
          -moz-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
          -moz-box-orient: vertical;
          box-orient: vertical;
        }

        .van-card-desc {
          position: absolute;
          bottom: 0.1rem;
          font-size: 0.24rem;
        }
      }

      .overGood {
        display: inline-block;
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        text-align: center;
        color: #fff;
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        bottom: 0rem;
        left: 0;
      }
      .van-card__footer {
        bottom: 0.14rem;
        padding-right: 0.2rem;
        .van-stepper {
          .van-stepper__minus,
          .van-stepper__plus {
            width: 0.5rem;
            height: 0.5rem;
          }
          .van-stepper__input {
            width: 0.5rem;
            height: 0.42rem;
          }
        }
      }
    }
  }
  .topnavbox {
    background: #fff;
    border-radius: 0.12rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/collect/collect.vue